import { LayoutViews, UserSettingsView } from 'enums';
import {
  iLoginData,
  iPermissionsData,
  iRoleData,
  iUpdateLoggedInUserData,
  iUserData,
  iUserSettings,
} from 'types';
import { USER } from '../constants';

export const userActions = {
  setLoginData: ({
    data,
    roles,
  }: {
    data: iLoginData;
    roles?: iRoleData[];
  }): any => ({
    type: USER.setLoginData,
    payload: { data, roles },
  }),
  setClientChoosed: (data: boolean): any => ({
    type: USER.setClientChoosed,
    payload: data,
  }),
  setUserPermissions: (data: iPermissionsData): any => ({
    type: USER.setUserPermissions,
    payload: data,
  }),
  set2FAData: (data: iUserSettings): any => ({
    type: USER.set2FAData,
    payload: data,
  }),
  changeUserRole: (roleId: string): any => ({
    type: USER.changeUserRole,
    payload: roleId,
  }),
  changeView: (data: LayoutViews | UserSettingsView) => ({
    type: USER.changeView,
    payload: data,
  }),
  setResetPasswordData: (data: { userId: string; email: string } | null) => ({
    type: USER.setResetPasswordData,
    payload: data,
  }),
  updateLoggedInUserData: (data: iUpdateLoggedInUserData | null) => ({
    type: USER.updateLoggedInUserData,
    payload: data,
  }),
  setRemoveTeammate: (data: iUserData | null) => ({
    type: USER.setRemoveTeammate,
    payload: data,
  }),
  setCanFetchRoles: (data: boolean) => ({
    type: USER.setCanFetchRoles,
    payload: data,
  }),
  setUserCompanyId: (data: string) => ({
    type: USER.setUserCompanyId,
    payload: data,
  }),
  setUserId: (data: string) => ({
    type: USER.setUserId,
    payload: data,
  }),
  // setCustomName: (data: iO365CustomName ) => ({
  //   type: USER.setCustomName,
  //   payload: data
  // })
};
